import ReactMarkdown from 'react-markdown';
import { provenanceFooter } from '../../utils/provenance';
import '../../styles/EditCase.css';

export default function DiagnosisContent({ diagnosis, onCopy, copySuccess, generatedAt, signoff }) {
    if (!diagnosis) return null;

    return (
        <div>
            <div className="document-toolbar">
                <button
                    type="button"
                    className={`copy-button ${copySuccess ? 'copied' : ''}`}
                    onClick={onCopy}
                >
                    {copySuccess ? '\u2713 Copied!' : 'Copy to Clipboard'}
                </button>
            </div>
            <div className="results-container">
                <div className="results-answer">
                    <ReactMarkdown>{diagnosis}</ReactMarkdown>
                </div>
            </div>
            <p className="provenance-footer">{provenanceFooter({ generatedAt, signoff })}</p>
        </div>
    );
}
